export {
  isAnalyticsEnabled,
  getGa4MeasurementId,
  isGa4Configured,
  shouldLoadAnalytics,
  isAnalyticsDebug,
} from './config';

export { pushToDataLayer } from './dataLayer';
export { AnalyticsEvents, ANALYTICS_INDUSTRIES, ANALYTICS_PLANS } from './events';
export {
  normalizeIndustry,
  normalizePlanTier,
  parseCommercialPlanCode,
  analyticsParamsFromPlan,
} from './industryPlan';
export { injectGtag, isGtagLoaded } from './gtag';

export {
  trackEvent,
  trackPageView,
  trackViewFeatures,
  trackViewPricing,
  trackViewDemo,
  trackClickContact,
  trackClickWhatsapp,
  trackClickDemo,
  trackSignupStarted,
  trackSignupCompleted,
  trackEmailVerified,
  trackLogin,
  trackIndustrySelected,
  trackPlanSelected,
  trackStartTrial,
  trackBeginCheckout,
  trackPurchase,
  trackSubscriptionCancelled,
  trackGenerateLead,
  trackDemoRequest,
  trackContactFormSubmit,
  trackCallbackRequest,
  trackAgencyCreated,
} from './trackers';

export { default as AnalyticsRouteTracker } from './AnalyticsRouteTracker';

import { injectGtag as injectGtagScript } from './gtag';

/** Initialize GA4 gtag once at application startup. */
export function initAnalytics() {
  injectGtagScript();
}
